<div class="flex flex-col items-center justify-center">
    <div class="w-full flex items-center justify-end">
        <button (click)="onDismiss()" class="w-6 h-6 rounded-md bg-gray-100">
            <i class="fas fa-times text-sm text-gray-500"></i>
        </button>
    </div>
    <p class="font-semibold font-display text-gray-700">Edit Proposal Status</p>
    <form [formGroup]="form" (ngSubmit)="onSave()" class="grid grid-cols-3 gap-2 mt-6 w-full font-display">
        <input type="text" formControlName="label" name="label" id="label" class="h-8 w-full col-span-2 rounded-md bg-gray-100 px-2 text-sm focus:outline-none" placeholder="Masukkan status proposal">
        <button class="h-8 w-full rounded-md bg-primary text-white flex items-center justify-center text-sm">Simpan</button>
    </form>
    <div class="overflow-x-auto w-full mt-4">
        <table mat-table [dataSource]="dataSource" class="w-full">

          <ng-container matColumnDef="no">
            <th mat-header-cell *matHeaderCellDef class="font-display"> No. </th>
            <td mat-cell *matCellDef="let element; let i = index" class="font-display"> {{parseNo(i)}} </td>
          </ng-container>
  
          <ng-container matColumnDef="label">
            <th mat-header-cell *matHeaderCellDef class="font-display whitespace-nowrap"> Proposal Status </th>
            <td mat-cell *matCellDef="let element" class="font-display whitespace-nowrap capitalize"> {{element.label}} </td>
          </ng-container>

          <ng-container matColumnDef="action">
              <th mat-header-cell *matHeaderCellDef class="font-display"> Action </th>
              <td mat-cell *matCellDef="let element" class="font-display">
                  <button [matMenuTriggerFor]="menu"><i class="fas fa-ellipsis-v text-sm text-gray-600"></i></button>
                  <mat-menu #menu="matMenu">
                      <button (click)="editData(element)" mat-menu-item class="font-display text-sm">Edit</button>
                      <button (click)="deleteData(element.id)" mat-menu-item class="font-display text-sm">Delete</button>
                  </mat-menu>
              </td>
            </ng-container>
        
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>
</div>